export default __webpack_public_path__ + "static/media/Beginner.7c56cb9f.png";